module.exports = __webpack_public_path__ + "img/card_vip.707e8fda.png";